import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	moreOptions: {
		id: 'software-filters-popup.common.more-options-dropdown.more-options',
		description: 'Label for the more options dropdown on filters popup',
		defaultMessage: 'More filter options',
	},
});
